// Canvas dimensions - fixed virtual canvas size
export const CANVAS_WIDTH = 5000;
export const CANVAS_HEIGHT = 5000;

// Viewport dimensions - functions to get current window size
export const VIEWPORT_WIDTH = () => typeof window !== 'undefined' ? window.innerWidth : 1024;
export const VIEWPORT_HEIGHT = () => typeof window !== 'undefined' ? window.innerHeight : 768;

// Shape styling
export const DEFAULT_FILL = '#cccccc';

// Canvas boundaries and constraints
export const CANVAS_BOUNDS = {
  minX: 0,
  minY: 0,
  maxX: CANVAS_WIDTH,
  maxY: CANVAS_HEIGHT
};

// Default shape dimensions
export const DEFAULT_SHAPE_SIZE = {
  width: 100,
  height: 80
};

// Performance and update constants
export const CURSOR_UPDATE_THROTTLE = 50; // milliseconds (20 FPS)
export const SHAPE_UPDATE_THROTTLE = 100; // milliseconds (10 FPS)

// Colors for user cursors and presence
export const USER_COLORS = [
  '#FF5733', // Red-Orange
  '#33C1FF', // Light Blue
  '#33FF77', // Green
  '#FF33E6', // Pink
  '#FFB533', // Orange
  '#8A33FF', // Purple
  '#33FFF5', // Cyan
  '#FF3366', // Red-Pink
  '#7CFF33', // Lime
  '#3366FF', // Blue
  '#FF7F33', // Orange-Red
  '#FF33B8'  // Magenta
];

// Canvas interaction settings
export const CANVAS_CONFIG = {
  dragBoundFunc: (pos) => ({
    x: Math.max(CANVAS_BOUNDS.minX, Math.min(pos.x, CANVAS_BOUNDS.maxX)),
    y: Math.max(CANVAS_BOUNDS.minY, Math.min(pos.y, CANVAS_BOUNDS.maxY))
  }),
  maxZoom: 3,
  minZoom: 0.1
};

// Firebase collection names
export const COLLECTIONS = {
  CANVAS: 'canvas',
  GLOBAL_CANVAS_ID: 'global-canvas-v1'
};

// Realtime Database paths
export const RTDB_PATHS = {
  SESSIONS: 'sessions',
  GLOBAL_SESSION: 'sessions/global-canvas-v1',
  getUserSession: (userId) => `sessions/global-canvas-v1/${userId}`,
  USER_SESSIONS: 'sessions/global-canvas-v1'
};
